"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayUtils = void 0;
var ArrayUtils;
(function (ArrayUtils) {
    function findOrThrow(arr, predicate, thisArg) {
        const result = arr.find(predicate, thisArg);
        if (result === undefined)
            throw new Error("Expected to find an element matching given predicate but got instead: undefined.");
        return result;
    }
    ArrayUtils.findOrThrow = findOrThrow;
    function single(arr, predicate, thisArg) {
        const results = arr.filter(predicate, thisArg);
        if (results.length > 1)
            throw new Error(`Expected to find a single element, but got instead: ${results.length}.`);
        return results[0];
    }
    ArrayUtils.single = single;
    function singleOrThrow(arr, predicate, thisArg) {
        const result = single(arr, predicate, thisArg);
        if (result === undefined)
            throw new Error(`Expected to find a single element, but got instead: undefined.`);
        return result;
    }
    ArrayUtils.singleOrThrow = singleOrThrow;
    function getOrThrow(arr, index) {
        const el = arr[index];
        if (el === undefined)
            throw new Error(`Expected to find an element at index: ${index}, but got instead: undefined.`);
        return el;
    }
    ArrayUtils.getOrThrow = getOrThrow;
    function remove(arr, item) {
        const idx = arr.indexOf(item);
        if (idx > -1)
            arr.splice(idx, 1);
    }
    ArrayUtils.remove = remove;
    function removeAll(arr, items) {
        for (const i of items) {
            remove(arr, i);
        }
    }
    ArrayUtils.removeAll = removeAll;
})(ArrayUtils = exports.ArrayUtils || (exports.ArrayUtils = {}));
//# sourceMappingURL=array.js.map